// @ts-nocheck
import React, { Fragment } from "react";

interface FooterProps {
  data?: boolean;
}
const Footer: React.FC<FooterProps> = ({ data }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const metrics = () => {
    (function (m, e, t, r, i, k, a) {
      m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) };
      m[i].l = 1 * new Date();
      for (var j = 0; j < document.scripts.length; j++) { if (document.scripts[j].src === r) { return; } }
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
    })
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(96484145, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    });
  }

  setTimeout(() => {
    metrics();
  }, 3000);

  return (
    <Fragment>
      <footer className="ki-layout-footer">
        <div className="ki-container">
          <div className="ki-layout-footer__base">
            <div className="ki-layout-footer__aside">
              <span className="ki-layout-footer__logo"></span>
              <ul className="ki-layout-footer__group">
                <li>
                  <a href="tel:+74952483737">+7 (495) 248-37-37</a>
                </li>
                <li>
                  <a href="mailto:info@ki112.ru">info@ki112.ru</a>
                  <span className="ki-layout-footer__label">Напишите нам!</span>
                </li>
              </ul>
            </div>

            <ul className="ki-layout-footer__group">
              <li>
                <address className="ki-layout-footer__address" itemScope="" itemProp="address" itemType="http://schema.org">
                  <p>
                    АО НИИ ИАТ: 121471, г. Москва, вн.тер.г. муниципальный округ Очаково-Матвеевское,
                    ул. Рябиновая, д. 26 стр. 1, этаж 6, помещ. 601, ком. 4.
                  </p>
                </address>
              </li>
            </ul>
          </div>

          <div className="ki-layout-footer__bottom">
            <p className="ki-layout-footer__copyright">
              @ 2016–{new Date().getFullYear()} АО «НИИ ИАТ»
            </p>
            <nav className="ki-layout-footer__links">
              <a className="ki-layout-footer__link" href="/privacy-policy">Политика конфиденциальности</a>
                <a className="ki-layout-footer__link" href="/processing-personal-data"> Обработка персональных данных</a>
            </nav>
          </div>
        </div>
      </footer>
      <noscript><div><img src="https://mc.yandex.ru/watch/96484145" style={{ position: 'absolute', left: '-9999px' }} alt="" /></div></noscript>
    </Fragment>
  )
};

export default Footer;
